import { useEffect } from "react"
import { useAuthInternal } from "./AuthProvider"
import { useNavigate } from "react-router-dom"

export function SigninCapture() {
    const { userManager, signinMode } = useAuthInternal()
    const navigate = useNavigate()

    const handleCallback = async () => {
        if (!userManager) {
            throw new Error("OIDC service not initialized")
        }

        const searchParams = new URLSearchParams(location.search)
        if (searchParams.get("code")) {
            try {
                const newUser = await userManager.signinCallback()

                if (signinMode === 'redirect') {
                    const returnUrl = (newUser?.state as any)?.returnUrl || "/"
                    navigate(returnUrl, { replace: true })
                }
            } catch (error) {
                console.log(`signinCallback failed: ${error}`)
            }
        }
    }

    useEffect(() => {
        if (userManager) {
            handleCallback()
        }
    }, [userManager])
    return <></>
}
